import { SignIn } from '@clerk/remix'

export default function SignInRoute() {
  return (
    <div className="m-10 flex justify-center">
      <SignIn />
    </div>
  )
}
